/* THIS FILE IS GENERATED. DO NOT EDIT */

import theme from 'sites/svenskdam/components/standalone/Banner/theme';

export const BannerTheme = theme;
